import "./FlatRoofs.module.css";
import Header from "@/reusable_sections/Header";
import PageHero from "@/components/PageHero";
import ServiceIntro from "@/components/service/ServiceIntro";
import ServiceCards from "@/components/service/ServiceCards";
import ServiceQuoteSection from "@/components/service/ServiceQuoteSection";
import OtherServices from "@/components/service/OtherServices";
import CtaBand from "@/components/CtaBand";
import Footer from "@/reusable_sections/Footer";
import FlatRoofQuoteForm from "./sections/GetAFreeQuote";
import { ShieldCheck, Layers, Flame, Wrench, Thermometer, ClipboardCheck } from "lucide-react";
const flatRoofCards = [{
  title: "EPDM Rubber Roofing",
  description: "Highly durable synthetic rubber membranes providing a seamless, waterproof finish with a lifespan of up to 50 years.",
  icon: ShieldCheck
}, {
  title: "Fibreglass Flat Roofs",
  description: "Tough, impact-resistant GRP roofing systems that are completely leak-proof and ideal for balconies or high-traffic areas.",
  icon: Layers
}, {
  title: "Felt Roofing",
  description: "Modern high-performance torch-on felt systems offering a cost-effective and reliable solution for all flat roof types.",
  icon: Flame
}, {
  title: "Flat Roof Repairs",
  description: "Rapid response leak detection and professional repairs to restore the integrity of your existing flat roofing system.",
  icon: Wrench
}, {
  title: "Roof Insulation",
  description: "Upgrade your property's energy efficiency with high-quality warm roof insulation installed during your flat roof project.",
  icon: Thermometer
}, {
  title: "Maintenance Plans",
  description: "Scheduled inspections and preventative maintenance to ensure your flat roof remains in peak condition year-round.",
  icon: ClipboardCheck
}];
export default function FlatRoofsPage() {
  return <div className="min-h-screen bg-background text-foreground flex flex-col">
      <Header />

      <PageHero eyebrow="OUR SERVICES" title="Flat Roofs in Southampton" intro="Specialising in high-performance flat roofing systems, we provide expert EPDM rubber installations and seamless GRP fibreglass solutions engineered for durability across Southampton, Hampshire & surrounding areas." imageSrc="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/flat_roof_epdm_installation.png" imageAlt="Professional flat roof installation with EPDM rubber in Southampton" breadcrumbLabel="Flat Roofs" breadcrumbParent={{
      label: "Services",
      to: "/ServicesHubPage"
    }} actions />

      <ServiceIntro eyebrow="EXPERT OVERVIEW" heading="Professional Flat Roofing Solutions in Southampton" paragraphs={[<p key="p1">
            As a trusted roofer in Southampton specialising in high-performance
            flat roofing systems, we provide expert EPDM rubber installations,
            seamless GRP fibreglass, and traditional felt solutions. Our durable,
            weather-resistant flat roofs are engineered for longevity, ensuring your
            property remains completely watertight and protected across Hampshire.
          </p>, <p key="p2">
            Whether you need a brand-new flat roof installation for a home extension,
            garage, or commercial property, or prompt flat roof repairs and warm-roof
            insulation upgrades, Matt and the Firststop Roofing Ltd team deliver
            meticulous roofing services in Southampton built to withstand British weather.
          </p>]} benefits={["Up to 50-year expected lifespan with seamless EPDM rubber membranes", "Tough, 100% leak-proof GRP fibreglass systems for roofs and balconies", "Energy-saving warm roof insulation and rapid leak repair services across Southampton"]} imageSrc="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/flat_roof_epdm_installation.png" imageAlt="Seamless flat roof installation in Southampton" cta />

      <ServiceCards eyebrow="WHAT WE OFFER" heading="Our Flat Roofing Services in Southampton" intro="Expert flat roofing solutions tailored to your property with premium materials and professional installation across Southampton, Hampshire & surrounding areas." items={flatRoofCards} columns={3} />

      <ServiceQuoteSection id="quote-section" eyebrow="GET A FREE QUOTE" heading="Request a Flat Roofing Quote in Southampton" intro="Tell us about your flat roof installation or repair project in Southampton or nearby Hampshire towns, and Matt will get back to you with honest advice and a transparent, competitive estimate." serviceName="Flat Roofs">
        <FlatRoofQuoteForm />
      </ServiceQuoteSection>

      <OtherServices currentKey="flat-roofs" />

      <CtaBand />

      <Footer />
    </div>;
}